import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'truncate'
})

export class TruncatePipe implements PipeTransform {

    transform(text: string, length: number = 20, suffix: string = '...'): string {

        if (text?.length > length) {
            return text.substring(0, length).trim() + suffix;
        }

        return text;
    }
}
